export default "__VITE_ASSET__BYXjXTo0__"